import { useEffect } from 'react';
import { isWeb } from '~/utils/device';
const alertUser = (e: any) => {
  e.returnValue = 'true';
  return 'true';
};
const useAlertReload = () => {
  useEffect(() => {
    if (isWeb) {
      const { window } = global as any;
      window.addEventListener('beforeunload', alertUser);
    }
    return () => {
      if (isWeb) {
        const { window } = global as any;
        window.removeEventListener('beforeunload', alertUser);
      }
    };
  }, []);
};

export default useAlertReload;
